import { sheetPresetSchema, type ViewConfig, type ViewConfigSheetPreset } from '@salescore/core'
import { Array, pipe, Result } from 'effect'

export type PresetParameterKeys = keyof ViewConfigSheetPreset

export const parsePresetParameterKeys = (v: unknown): PresetParameterKeys[] =>
  sheetPresetSchema.keyof().array().safeParse(v).data ?? []

/**
 * 値が設定されているプリセットの項目のキーを返す。
 * プリセットの項目に無いキー (シートの設定の `type` 等) が 1 つでも含まれると、parsePresetParameterKeys の検証に落ちて空配列になる
 */
export const getDefinedPresetParameterKeys = (
  presetOrConfig: ViewConfigSheetPreset | ViewConfig,
): PresetParameterKeys[] =>
  parsePresetParameterKeys(
    pipe(
      Object.entries(presetOrConfig),
      Array.filterMap(([k, v]) => (v === undefined ? Result.failVoid : Result.succeed(k))),
    ),
  )
